import { render, staticRenderFns } from "./Facebook.vue?vue&type=template&id=023ac0a5&scoped=true&"
import script from "./Facebook.vue?vue&type=script&lang=js&"
export * from "./Facebook.vue?vue&type=script&lang=js&"
import style1 from "./Facebook.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Facebook.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023ac0a5",
  null
  
)

export default component.exports